import { render, staticRenderFns } from "./HeadlineXSmall.vue?vue&type=template&id=49d365fc&scoped=true&"
import script from "./HeadlineXSmall.vue?vue&type=script&lang=ts&"
export * from "./HeadlineXSmall.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineXSmall.vue?vue&type=style&index=0&id=49d365fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d365fc",
  null
  
)

export default component.exports